import { getUserProfile, UserProfile } from 'api/services';
import { useQuery, UseQueryOptions } from 'react-query';
import { useAuth } from 'state/auth';
import { userProfileQueries } from './queryKeys';
import { profileInfoSelector, verifiedEmailSelector } from './selectors';

type QueryKey = ReturnType<typeof userProfileQueries.user>;

function useProfile<TData = UserProfile>(
  opts: Omit<
    UseQueryOptions<UserProfile, unknown, TData, QueryKey>,
    'queryKey' | 'queryFn'
  >,
) {
  const { userId, accessToken } = useAuth();

  return useQuery<UserProfile, unknown, TData, QueryKey>(
    userProfileQueries.user(userId as number),

    () => getUserProfile({ token: accessToken, userId: userId as number }),
    {
      enabled: !!userId,
      staleTime: Infinity,
      ...opts,
    },
  );
}

export function useProfileInfo() {
  return useProfile({ select: profileInfoSelector });
}

export function useIsEmailVerified() {
  return useProfile({ select: verifiedEmailSelector });
}
